import { useEffect, useState } from 'react';

/**
 * Load employee photograph via authenticated fetch (blob URL).
 * Works for header avatars and profile icons when direct <img src> fails.
 * Added refreshKey to bust cache after upload.
 */
export function useEmployeePhoto(employeeId, refreshKey = 0) {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!employeeId) {
      setSrc(null);
      return undefined;
    }

    let cancelled = false;
    let objectUrl = null;

    const load = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('access_token');
        const url = `/api/v1/benfish-employees/${employeeId}/photograph?ts=${refreshKey}`;
        const res = await fetch(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          cache: 'no-store',
        });
        if (!res.ok) {
          if (!cancelled) setSrc(null);
          return;
        }
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) {
          setSrc((prev) => {
            if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
            return objectUrl;
          });
        }
      } catch {
        if (!cancelled) setSrc(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [employeeId, refreshKey]);

  return { src, loading };
}
